// extracted by mini-css-extract-plugin
export default {"footer":"Section2_footer__lmEQ0","udaan":"Section2_udaan__LvyGb"};